import { ControlOutlined } from '@ant-design/icons';
import { ListFixedHeader } from '@src/components';
import { Card } from '@src/controls';
import { DOMAIN } from '@src/dictionaries';
import { getCustomBookingMethodsByCurrentSite } from '@src/modules/config/selectors';
import { useMasterSiteId, useSelector } from '@src/utils/hooks';
import React, { FC, Fragment } from 'react';
import { style as tss } from 'typestyle';
import { EmptyList } from './empty-list';
import { BookingMethodCard } from './shipment-method-card';
import { excludedSiteIds, NewExperienceAlert } from '@src/components/new-experience-alert';
import { getTransportUrl } from '@src/services/transport-service';

export const BookingRules: FC = () => {
  const customBookingMethods = useSelector(getCustomBookingMethodsByCurrentSite);
  const isFetching = useSelector(state => state.config.isFetching);
  const siteId = useMasterSiteId();

  const isEmptyList = customBookingMethods.every(bookingMethodModel => !bookingMethodModel.steps);

  const virtualMethodsList = customBookingMethods.map(bookingMethodModel => (
    <BookingMethodCard key={bookingMethodModel.method} bookingMethodModel={bookingMethodModel} />
  ));

  const transportUrl = getTransportUrl(siteId, '/settings/booking-rules');

  if (!excludedSiteIds.includes(siteId)) {
    window.location.href = transportUrl;
    return null;
  }

  return (
    <Fragment>
      <NewExperienceAlert link={transportUrl} />

      <ListFixedHeader
        title={DOMAIN.BOOKING_RULES}
        IconComponent={ControlOutlined}
        isLoading={false}
        showSearch={false}
      />
      <Card loading={isFetching} className={styles.card}>
        {!isEmptyList && !isFetching ? virtualMethodsList : <EmptyList />}
      </Card>
    </Fragment>
  );
};

const styles = {
  card: tss({
    $nest: {
      '.ant-card-body': {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      },
    },
  }),
};
